// tslint:disable:max-line-length

import React from 'react';

export const ArrowChevronRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M9.5,8L3,16h3.5l5.3-6.6L13,8l-1.2-1.4L6.6,0H3L9.5,8z" />
    </svg>
  );
};
